import ETreeNodeTypes from 'enums/ETreeNodeTypes';

export const AllowedTypesForRootProjects: ETreeNodeTypes[] = [
  ETreeNodeTypes.Project,
  ETreeNodeTypes.ProjectsFolder,
];

export const AllowedTypesForRootSearches: ETreeNodeTypes[] = [
  ETreeNodeTypes.SearchAnalysis,
  ETreeNodeTypes.SearchesFolder,
];

export const AllowedTypesForRootSynchTrips: ETreeNodeTypes[] = [
  ETreeNodeTypes.SynchrotronTripv4,
  ETreeNodeTypes.SynchrotronTripv4Folder,
];

export enum ERightClickAction {
  Refresh = 'Refresh',
  Open = 'Open',
  ExportPOI = 'Export POI',
  Analyze = 'Analyze',
  Export = 'Export',
  NewFolder = 'New Folder',
  NewScreen = 'New Screen',
  NewProject = 'New Project',
  NewExperiment = 'New Experiment',
  NewProteinFormulation = 'New Protein Formulation',
  NewFragmentScreen = 'New Fragment Screen',
  NewSynchrotronTrip = 'New Synchrotron Trip',
  NewSearchFolder = 'New Search Folder',
  NewSearchAndFilter = 'New Search and Filter',
  Cut = 'Cut',
  Copy = 'Copy',
  Paste = 'Paste',
  Delete = 'Delete',
  Rename = 'Rename',
  SynchrotronTripReport = 'Synchrotron Trip Report',
  ImageNow = 'Image Now',
  MarkAsNotSeen = 'Mark as Not Seen',
  ExportToTextFile = 'Export To Text File',
  ExportToXmlFile = 'Export To XML File',
  ExperimentReport = 'Experiment Report',
  ScreenStocksReport = 'Screen Stocks Report',
  RotateCanvas = 'Rotate Canvas',
  NewProteinVariant = 'New Protein Variant',
  PrintBarcode = 'Print Barcodes',
  HitsReport = 'Hits Report',
  ChangeSchedule = 'Change Schedule',
  SendToAutoScore = 'Send to Auto Score',
}

export const KeyboardShortcutsLables = {
  Cut: 'Ctrl+X',
  Copy: 'Ctrl+C',
  Delete: 'Del',
  Rename: 'F2',
  Paste: 'Ctrl+V',
};

export const AllowedTypesForRootScreens: ETreeNodeTypes[] = [
  ETreeNodeTypes.ScreensFolder,
  ETreeNodeTypes.Screen,
];

export const allowedRootTypesMap = {
  [ETreeNodeTypes.Projects]: AllowedTypesForRootProjects,
  [ETreeNodeTypes.Searches]: AllowedTypesForRootSearches,
  [ETreeNodeTypes.CrystalTrackv4]: AllowedTypesForRootSynchTrips,
  [ETreeNodeTypes.Screens]: AllowedTypesForRootScreens,
} as { [key: string]: ETreeNodeTypes[] };

export const searchesOnlyFolders = [
  ETreeNodeTypes.Searches,
  ETreeNodeTypes.SearchesFolder,
];

export const searchAndFilterFolders = [
  ...searchesOnlyFolders,
  ETreeNodeTypes.ProjectsFolder,
  ETreeNodeTypes.ProjectFolder,
  ETreeNodeTypes.Project,
];

export const progressTitle = 'Updating, please wait…';
export const progressMessage =
  'This process may take a few moments. Please do not close or refresh the page.';
